<div>
  <kt-generic-button
    appearance="flat"
    [color]="props['color']"
    [disabled]="!!props.disabled"
    (click)="onClick($event)"
  >
    {{ props['text'] }}
  </kt-generic-button>
</div>
